export const WHATSAPP_NUMBER = '923439756320';

export const whatsappUrl = (dressName, pageUrl) => {
  const text = `Hello, I need to know more about ${dressName} ${pageUrl}`;
  return `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}&text=${encodeURIComponent(text)}`;
};
